import React from "react";

const Input = ({
  className = "",
  sizeClass = "h-11 px-4 py-3",
  fontClass = "text-sm font-normal",
  rounded = "rounded-xl",
  children,
  type = "text",
  defaultValue = "",
  required = false,
  ...args
}) => {
  return (
    <input
      className={`block w-full text-black bg-white border border-black text-[15px] focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 ${rounded} ${fontClass} ${sizeClass} ${className}`}
      type={type}
      defaultValue={defaultValue}
      required={required}
      {...args}
    />
  );
};

// ref={ref}
// type={type}
// className={`block w-full text-black bg-white border border-black text-[15px] focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 ${rounded} ${fontClass} ${sizeClass} ${className}`}
// {...args}
// placeholder={defaultValue}
// required={required}

export default Input;
